import { FormattedMessage } from 'react-intl'
import { useState } from 'react'
import CreateTokenDialog from '@components/dialog/CreateTokenDialog/CreateTokenDialog'

import './CreateTokenButton.css'

export default function CreateTokenButton() {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <button
        className="button create-token-button highlight-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FormattedMessage id="tokens-empty-list.button" />
      </button>
      <CreateTokenDialog isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  )
}
